export const DEFAULT_CENTER = { lat: 49.841328, lng: 24.031592 };
export const DEFAULT_BOUNDS = {
  sw: { lat: 49.83656742688311, lng: 24.02260123538207 },
  ne: { lat: 49.84608810441344, lng: 24.04058276461791 },
};
export const DEFAULT_ZOOM = 15;
